module.exports = __webpack_public_path__ + "static/media/rsv.bc36c92d.jpg";